{
  "addNewAccount": "Neues Konto hinzufügen",
  "clickSubmitToContinue": "Klicke auf \"Absenden\" um fortzufahren.",
  "thatsAllWeNeed": "Das ist alles, was wir brauchen.",
  "errorCompleteStep": "Schliesse bitte zuerst diesen Schritt ab.",
  "back": "Zurück",
  "next": "Weiter",
  "cancel": "Abbrechen",
  "submit": "Absenden",
  "pressNextToContinue": "Klicke auf \"Weiter\" um fortzufahren.",
  "pressSubmitToFinish": "Klicke auf \"Absenden\" um fortzufahren.",
  "currentBalance": "Aktuelles Saldo",
  "common": {
    "whenIBuy": "Wenn du {{categorySingle}} kaufst, das Geld...",
    "existingAccount": "...wird von einem bestehenden Bankkonto abgezogen.",
    "existingAccountSelect": "Wähle dieses Bankkonto aus.",
    "createAccountLater": "... wird von einem Bankkonto abgebucht, das ich später einrichten werde.",
    "createAccountLaterDescription": "Sobald du dieses Konto eingerichtet hast, denke daran, das verknüpfte Konto in diesem Konto zu aktualisieren."
  },
  "D1": {
    "accountType": "Kontoart",
    "whatKindOfAccount": "Welche Art von Konto möchtest du hinzufügen? Wähle die Option, die am besten zu deinem Konto passt.",
    "products": {
      "savings-account-giro": "Bankkonto für deine täglichen Ausgaben und Ausgaben. Du kannst jederzeit Geld abheben und einzahlen.",
      "savings-account-tagesgeld": "Ein Sparbuch, in dem du - theoretisch - etwas mehr Zinsen als mit deinem Girokonto erhältst, aber oft daran gehindert bist, wann du abheben kannst.",
      "savings-account-generic": "Bankkonto für deine täglichen Ausgaben und Ausgaben. Du kannst jederzeit Geld abheben und einzahlen.",
      "time-deposit-festgeld": "Bankeneinlage, die du bis zu ihrem Fälligkeitstermin nicht abheben kannst.",
      "time-deposit-generic": "Bankeneinlage, die du bis zu ihrem Fälligkeitstermin nicht abheben kannst."
    }
  },
  "D2": {
    "automaticOrManual": "Automatisch oder manuelle Updates",
    "updateAutomatically": "Möchtest du, dass wir deine Daten automatisch abrufen? Du kannst es später ändern.",
    "automatic": {
      "label": "Automatische Synchronisierung",
      "description": "Wir stellen eine sichere Verbindung zu deiner Bank her und kümmern uns um das Abrufen der letzten Transaktionen. Du musst möglicherweise deine Bank-App verwenden, um diesen Vorgang zu bestätigen. Eine manuelle Import ist immer noch möglich."
    },
    "manual": {
      "label": "Manuelle Updates",
      "description": "Du kannst auch unseren intelligenten Datenimport verwenden, um Daten über deine Konten einfach zu übertragen. Alles, was du tun musst, ist, die Transaktionen von deiner Bank-Website herunterzuladen und hier hochzuladen."
    }
  },
  "D3": {
    "bank": "Bank",
    "banks": "Banken",
    "aBank": "eine Bank",
    "yourBank": "deine Bank",
    "broker": "Broker",
    "brokers": "Broker",
    "aBroker": "einen Broker",
    "yourBroker": "deinen Broker",
    "accountCountry": "Land des Kontos",
    "accountCountryBody": "In welchem Land befindet sich das Institut, wo das Konto geführt wird?",
    "selectCountry": "Wähle Land",
    "select": "Wähle {{yourInstitutionType}} aus",
    "selectCountryFirst": "Wähle zuerst das Land oben.",
    "retrievingInstitutions": "Wir bereiten die Liste vor...",
    "nothingFound": "In diesem Land sind {{yourInstitutions}} leider noch nicht angebunden. Füge {{yourInstitutionType}} manuell mit dem Knopf unten hinzu.",
    "noSlots": "Du hast bereits die maximale Anzahl von automatischen Updates bei ausländischen Finanzinsituten erreicht. Füge {{yourInstitutionType}} manuell mit dem Knopf unten hinzu.",
    "findYourBank": "Finde {{yourInstitutionType}} in der Liste, um deine Daten automatisch zu synchronisieren.",
    "cannotFind": "Wenn du deine Bank hier nicht finden kannst, ist eine automatische Datensynchronisierung noch nicht möglich. Geh einen Schritt zurück und wähle >Manual updates<",
    "noResultsFound": "Keine Ergebnisse gefunden",
    "thisAccountManual": "Dieses Konto wird nicht automatisch synchonisiert. Daten könnem manuell importiert oder eingegeben werden.",
    "thisAccountManual2": "Um automatische Synchronisierung zu aktivieren, wähle {{anInstitutionType}} aus der Liste oben.",
    "thisAccountManual3": "Fortsetzen mit >Weiter<.",
    "addManualAccount": "Bank manuell hinzufügen",
    "intelligentImport": "Dies ist die Liste aller Banken, wo wir deine Daten automatisch abfragen können. Falls du deine Bank hier nicht finden kannst, kannst du deine Daten manuell importieren.",
    "couldNotFindAnything": "Für diesen Begriff gab es keine Suchtreffer. Bitte versuche es erneut.",
    "youHaveSelected": "Deine Auswahl",
    "yourSelection": "Deine Auswahl",
    "details": "Details der ausgewählten Bank",
    "search": "Suche"
  },
  "D4": {
    "account": "Konto",
    "accountInfo": "Kontodaten",
    "accountInfoManual": "Bitte gib einige Informationen zu deinem Konto an.",
    "accountInfoAutomatic": "Deine Bank hat uns diese Kontoinformationen übermittelt.",
    "accountInfoAutomatic2": "Deaktiviere >Dieses Konto wird erstellt<, um zu verhindern, dass es in Monestry erstellt wird.",
    "whichCashAccount": "Welches Bankkonto verwendest du, um Wertpapiere zu kaufen und zu verkaufen?",
    "whyDoWeAsk": "Warum benötigen wir ein verbundenes Bankkonto?",
    "whyDoWeAskAnswer": "Wir berechnen die Rendite aus der Investition und das Kapitaleinkommen anhand von Bewegungen auf Bankkonten, aus denen die Aktienumsätze abgezogen oder gutgeschrieben werden.",
    "notHaveAccount": "Was ist, wenn ich kein separates Bankkonto habe?",
    "notHaveAccountAnswer": "Wenn dein Broker alle Bargeldtransaktionen abwickelt, erstellen wir ein 'technisches Konto', damit du ein besseres Bild von allen Transaktionen hast - wähle dazu einfach die Option am Ende des Formulars.",
    "whenIBuy": "Wenn ich Wertpapiere kaufe, wird das Geld...",
    "existingAccount": "... von einem vorhandenen Bankkonto abgezogen",
    "existingAccountSelect": "Wähle das Bankkonto aus",
    "createTechnicalAccount": "... von einem Bankkonto bei meiner Brokerfirma abgezogen",
    "createTechnicalAccountCurrency": "In welcher Währung ist dieses Bankkonto?",
    "createAccountLater": "... von einem Bankkonto abgezogen, das ich später einrichte",
    "createAccountLaterDescription": "Sobald das neue Bankkonto angelegt wird, öffne die Detailansicht dieses Kontos und füge es hinzu.",
    "gettingAdditionalAccountInformation": "Zusätzliche Kontoinformationen werden abgerufen...",
    "providerAllAccountsAdded": "Keine neue Kontos gefunden. Alle Konten wurden bereits hinzugefügt.",
    "accountName": {
      "label": "Kontoname",
      "tooltip": "Unter welchem Namen möchtest du dieses Konto im System sehen?",
      "error": "Bitte gebe eine Bezeichnung für dieses Konto ein."
    },
    "baseCurrency": {
      "label": "Basiswährung",
      "tooltip": "Welche Währung möchtest du als Basiswährung verwenden? In der Regel ist dies die Währung, in der du verdienst."
    },
    "iban": {
      "label": "IBAN",
      "tooltip": "Die IBAN-Nummer dieses Kontos. Beginnt mit einem Land-Kürzel z.B. >DE< für Deutschland.",
      "placeholder": "DE12345678901234567890"
    },
    "bic": {
      "label": "BIC",
      "tooltip": "Internationaler Bankcode (genannt >BIC<) für die Bank, bei der dieses Konto geführt wird. Bis zu 11 Zeichen lang. Dient zur Identifikation einer Bank im internationalen Kontext."
    },
    "bankName": {
      "label": "Bankname",
      "tooltip": "Name der Bank, bei der dieses Konto geführt wird.",
      "placeholder": "Sparkasse Bielefeld"
    },
    "brokerName": {
      "label": "Brokername",
      "tooltip": "Bei welchem Broker ist dieses Konto?",
      "placeholder": "DepotX"
    },
    "isImported": {
      "label": "Dieses Konto wird erstellt.",
      "tooltip": "Entferne das Häkchen, um zu verhindern, dass dieses Konto erstellt wird.",
      "error": "Dein Abo erlaubt nur {{num}} weitere Konten.",
      "error1": "Dein Abo erlaubt nur ein weiteres Konto.",
      "error0": "Dein Abo erlaubt keine weitere Konten."
    },
    "connectedDepositMode": {
      "error": "Bitte wähle eine Option aus."
    },
    "accountNo": {
      "label": "Depotnummer",
      "tooltip": "Welche Nummer trägt dein Depot?",
      "placeholder": "C12345678"
    },
    "connectedCashAccount": "Verbundenes Girokonto"
  },
  "R1": {
    "accountInfo": "Kontoinformationen",
    "provideInfo": "Bitte gebe einige Informationen zu deiner Immobilie an.",
    "oneAccount": "Ein Konto deckt genau eine Immobilie ab - wenn du mehr als eines hast, erstelle mehr Konten.",
    "whyDoWeAsk": "Warum wollen wir das wissen?",
    "whyDoWeAskAnswer": "Das sind alle Parameter, die verwendet werden, um den Wert deiner Immobilie zu berechnen.",
    "doIHaveToFillThemAllOut": "Muss ich alle Felder ausfüllen?",
    "doIHaveToFillThemAllOutAnswer": "Nein, aber je mehr Informationen du angibst, desto genauer wird die automatische Bewertung deiner Immobilie.",
    "name": {
      "label": "Immobilienname",
      "tooltip": "Welchen Namen möchtest du in der App für diese Immobilie sehen?",
      "placeholder": "Wohnung in Bielefeld",
      "error": "Bitte gebe deine Bezeichnung für diese Immobilie an."
    },
    "originalPrice": {
      "label": "Kaufpreis",
      "tooltip": "Wie viel hat die Immobilie gekostet?",
      "placeholder": "456000",
      "error": "Solange Kaufdatum angegeben ist, muss auch der Kaufpreis vorhanden sein. Er kann nachher geändert werden."
    },
    "currency": {
      "label": "Währung",
      "tooltip": "In welcher Währung möchstest du die Wertentwicklung dieser Immobilie verfolgen? Typischerweise ist dies die Wahrung des Landes, in dem die Immobilie liegt. Umrechnung in deine Basiswährung erfolgt automatisch."
    },
    "automaticUpdate": {
      "label": "Automatische Wertaktualisierung?",
      "tooltip": "Schalte es ein, um automatische Aktualisierungen des Immobilienweres zu aktivieren. Du kannst es später ändern.",
      "disabled": "Automatische Wertaktualisierung bereits eingesetzt oder nicht verfügbar."
    },
    "date": {
      "label": "Kaufdatum",
      "tooltip": "Seit wann besizt du diese Immobilie? Du kannst dieses Datum nachher ändern.",
      "placeholder": "2015-05-15",
      "error": "Solange Kaufpreis angegeben ist, muss auch das Kaufdatum vorhanden sein. Es kann nachher geändert werden."
    },
    "kindOfProperty": "Um was für eine Immobilie handelt es sich?",
    "type": {
      "label": "Immobilientyp",
      "apartment": "Wohnung",
      "house": "Haus"
    },
    "streetAddress": {
      "label": "Straße und Nummer",
      "tooltip": "Wo befindet sich deine Immobilie?",
      "placeholder": "Hochstr. 12"
    },
    "zip": {
      "label": "Postleitzahl",
      "tooltip": "Welche Postleitzahl hat deine Immobilie?",
      "placeholder": "33602"
    },
    "city": {
      "label": "Stadt",
      "tooltip": "In welcher Stadt / Stadt / Dorf befindet sich deine Immobilie?",
      "placeholder": "Bielefeld"
    },
    "country": {
      "label": "Land",
      "tooltip": "In welchem Land befindet sich deine Immobilie?",
      "placeholder": "Deutschland"
    },
    "livingArea": {
      "label": "Gesamtfläche",
      "tooltip": "Wie groß ist deine Immobilie (in Quadratmetern)?",
      "placeholder": "88"
    },
    "rooms": {
      "label": "Zimmer",
      "tooltip": "Wie viele Zimmer hat deine Immobilie?",
      "placeholder": "3"
    },
    "lotArea": {
      "label": "Grundstücksfläche",
      "tooltip": "Wie groß ist das Grundstück, auf dem sich deine Immobilie befindet (in Quadratmetern)?",
      "placeholder": "450"
    },
    "constructionYear": {
      "label": "Baujahr",
      "tooltip": "Wann wurde deine Immobilie gebaut?",
      "placeholder": "2010"
    },
    "parking": {
      "label": "Privatparkplatz inklusive?"
    }
  },
  "S1": {
    "accountInformation": "Konteninformationen",
    "description": "Geben Sie uns einige Informationen über dein Konto.",
    "whyDoWeAsk": "Warum fragen wir?",
    "whyDoWeAskAnswer": "Wir verwenden Daten wie Kontonummer, Benutzername, verbundenes Cash-Konto, um Bargeldtransaktionen mit Ihren Börsentransaktionen zu verknüpfen. Du musst sie nicht angeben, aber unser System kann möglicherweise die entsprechenden Transaktionen nicht verknüpfen und du musst diese möglicherweise manuell durchführen.",
    "name": {
      "label": "Kontoname",
      "tooltip": "Welchen Namen möchtest du in dieser App für dieses Konto sehen?",
      "placeholder": "DepotX-Brokerkonto",
      "error": "Bitte geben Sie Ihre Bezeichnung für dieses Konto ein."
    },
    "username": {
      "label": "Dein Benutzername für dieses Brokerkonto",
      "tooltip": "Der Benutzername, mit dem du dich in dieses Konto einloggst.",
      "placeholder": "ab12345678"
    }
  },
  "S2": {
    "connectedCashAccount": "Verbundenes Bankkonto",
    "whichCashAccount": "Welches Bankkonto verwendest du, um Wertpapiere zu kaufen und zu verkaufen?",
    "whyDoWeAsk": "Warum benötigen wir ein verbundenes Bankkonto?",
    "whyDoWeAskAnswer": "Wir berechnen die Rendite aus der Investition und das Kapitaleinkommen anhand von Bewegungen auf Bankkonten, aus denen die Aktienumsätze abgezogen oder gutgeschrieben werden.",
    "notHaveAccount": "Was ist, wenn ich kein separates Bankkonto habe?",
    "notHaveAccountAnswer": "Wenn dein Broker alle Bargeldtransaktionen abwickelt, erstellen wir ein 'technisches Konto', damit du ein besseres Bild von allen Transaktionen hast - wähle dazu einfach die Option am Ende des Formulars.",
    "whenIBuy": "Wenn ich Wertpapiere kaufe, wird das Geld...",
    "existingAccount": "... von einem vorhandenen Bankkonto abgezogen",
    "existingAccountSelect": "Wähle das Bankkonto aus",
    "createTechnicalAccount": "... von einem Bankkonto bei meiner Brokerfirma abgezogen",
    "createTechnicalAccountCurrency": "In welcher Währung ist dieses Bankkonto?",
    "createAccountLater": "... von einem Bankkonto abgezogen, das ich später einrichte",
    "createAccountLaterDescription": "Sobald das Bankkonto hinzugefügt wird, öffnen Du die Detailansicht dieses Kontos und verknüpfen Du das Bankkonto dort."
  },
  "loans": {
    "given": "Darlehen gegeben",
    "taken": "Darlehen genommen",
    "provideSomeParameters": "Bitte gib einige Parameter an, die wir verwenden werden, um zukünftige Darlehenszahlungen zu simulieren. Du musst keine vergangenen Änderungen eingeben, da diese bereits in den Transaktionen des Darlehenskontos berücksichtigt sind.",
    "loanAmount": {
      "label": "Darlehensbetrag",
      "tooltip": "Gib den Gesamtbetrag des Darlehens ein (nur Hauptbetrag/Kapital).",
      "error": "Bitte gib den Darlehensbetrag ein."
    },
    "direction": {
      "label": "Darlehen genommen oder gegeben?",
      "tooltip": "Wenn du Geld geliehen hast, wähle 'genommen'; sonst wähle 'gegeben'.",
      "error": "Bitte markiere, ob das Darlehen genommen oder gegeben ist."
    },
    "period": {
      "month": "Monat",
      "quarter": "Quartal",
      "year": "Jahr",
      "label": "Raten werden alle",
      "placeholder": "Periode auswählen",
      "tooltip": "Wie oft zahlst du Darlehensraten?",
      "error": "Bitte wähle die Ratenzahlungsperiode."
    },
    "interestRate": {
      "text": "Zinssatz und in einigen Fällen kann sich der Ratenbetrag über die Zeit ändern. Verwende die >Erweitert< Schaltfläche, wenn du diese Änderungen jetzt eingeben möchtest. Du kannst dies auch später tun.",
      "label": "Zinssatz (%)",
      "tooltip": "Gib den jährlichen Zinssatz für das Darlehen ein.",
      "error": "Bitte gib den jährlichen Zinssatz in % ein."
    },
    "endDate": {
      "text": "Wenn du ein Enddatum eingibst, wird die Simulation die letzte Rate als die gesamte ausstehende Schuld berechnen (auch als Ballonzahlung oder Restschuld bekannt). Wenn du vorhast, ein anderes Darlehen aufzunehmen, gib hier das Enddatum ein und erstelle ein anderes Darlehenskonto, das im Monat der letzten Rate dieses Darlehens beginnt.",
      "label": "Enddatum des Darlehensvertrags",
      "tooltip": "Wann endet der Darlehensvertrag? Du kannst dieses Feld leer lassen.",
      "error": "Datum muss in Zukunft liegen."
    },
    "calculateUntilEnd": {
      "label": "Bis zur vollständigen Rückzahlung simulieren",
      "tooltip": "Wenn du die Darlehenszahlungen bis zum Ende der Darlehenslaufzeit simulieren möchtest, wähle diese Option."
    },
    "advanced": "Erweitert",
    "installmentCalc": "Ist die Darlehensrate jedes Mal gleich? Wähle 'Annuität'. Wird sie jedes Mal niedriger (du zahlst jeden Monat einen festen Kapitalbetrag mit wechselnden Zinsen zurück)? Wähle 'Festes Kapital'. Wenn du nur die Zinsen zurückzahlst (das Kapital wird am Ende der Laufzeit zurückgezahlt), wähle 'Nur Zinsen'. Vergiss nicht, ein Enddatum einzugeben, damit wir die letzte Rate berechnen können.",
    "type": {
      "annuity": "Annuität",
      "fixedPrincipal": "Festes Kapital",
      "interestOnly": "Nur Zinsen",
      "label": "Ratentyp",
      "tooltip": "Wie wird deine Rate berechnet? Siehe Hinweis links zur Erklärung.",
      "error": "Bitte wähle den Ratentyp."
    },
    "byInstallentAmount": "Gib den Betrag jeder Rate (Annuität) ein.",
    "byTilgungsrate": "Gib den Prozentsatz des Darlehensbetrags ein, der jährlich zurückgezahlt werden soll ('Tilgungsrate').",
    "annuitySubtype": {
      "error": "Bitte wähle eine Option."
    },
    "annuitySubtypeAmount": {
      "label": "Ratenbetrag",
      "tooltip": "Gib den Betrag für deine feste Rate ein.",
      "error": "Bitte gib den Betrag für deine feste Rate ein."
    },
    "annuitySubtypeTilgung": {
      "label": "Jährliche Tilgung (%)",
      "tooltip": "Gib den Prozentsatz des Darlehensbetrags an, der jährlich zurückgezahlt wird.",
      "error": "Bitte gib den Prozentsatz des jährlich zurückgezahlten Darlehensbetrags ein."
    },
    "fixedPrincipalSubtype": {
      "error": "Bitte wähle eine Option."
    },
    "byPrincipalRepaid": "Gib den Betrag des Kapitals (Hauptbetrag) ein, der in jeder Periode zurückgezahlt wird.",
    "fixedPrincipalSubtypeAmount": {
      "label": "Hauptbetrag",
      "tooltip": "Gib den Hauptbetrag (Kapital) ein, der in jeder Periode zurückgezahlt wird.",
      "error": "Bitte gib den Betrag ein, der in jeder Periode zurückgezahlt wird."
    },
    "fixedPrincipalSubtypeTilgung": {
      "label": "Jährliche Tilgung (%)",
      "tooltip": "Gib den Prozentsatz des Darlehensbetrags an, der jährlich zurückgezahlt wird.",
      "error": "Bitte gib den Prozentsatz des jährlich zurückgezahlten Darlehensbetrags ein."
    },
    "connectedDepositAccount": "Um die Darlehensauszahlungen und -zahlungen nachzuverfolgen, müssen wir wissen, von welchem Konto das Geld kommt und wohin es geht. Wenn du mehr als eines verwendest, kannst du das andere Konto später hinzufügen.",
    "connectedDepositMode": {
      "error": "Bitte wähle, wie du das Einzahlungskonto verbinden möchtest."
    },
    "existingAccount": "Bestehendes Konto",
    "existingAccountSelect": "Wähle ein bestehendes Konto",
    "createAccountLater": "Konto später erstellen",
    "createAccountLaterDescription": "Du kannst wählen, später ein Einzahlungskonto zu verbinden.",
    "loanProject": "Du kannst die simulierten zukünftigen Zahlungen in Projekten sehen. Wenn du bereits ein Projekt für dieses Darlehen hast, wähle es hier. Wenn nicht, markiere >Neues Projekt erstellen<.",
    "connectedProjectId": {
      "label": "Verbundenes Projekt",
      "tooltip": "Wähle das mit diesem Darlehen verbundene Projekt."
    },
    "projectCreateNew": "Erstelle ein neues Projekt",
    "bereitstellungszinsen": {
      "text": "Zinsen vor vollständiger Darlehensauszahlung (Bereitstellungszinsen)",
      "label": "Anfänglicher Zinssatz (%)",
      "tooltip": "Gib den Zinssatz ein, der auf den nicht ausgezahlten Teil des Darlehens erhoben wird."
    },
    "bereitstellungszinsenSinceDate": {
      "label": "Beginnend am",
      "tooltip": "Gib das Datum an, ab dem die Bereitstellungszinsen berechnet werden."
    },
    "interestAfterTerm": {
      "text": "Wende neuen Zinssatz nach Ende des Darlehensvertrags an. Dies ermöglicht die Option 'bis zur vollständigen Rückzahlung simulieren' oben und wendet diesen Zinssatz ab dem angegebenen Datum an.",
      "label": "Zinssatz nach Vertragsende (%)",
      "tooltip": "Gib den Zinssatz ein, der nach dem ursprünglichen Ende der Laufzeit gilt."
    },
    "interestAfterTermSinceDate": {
      "label": "Beginnend am",
      "tooltip": "Gib das Startdatum für den Zinssatz nach Vertragsende an."
    },
    "interestCalculationCutoff": "Berechnet deine Bank deine Rate zu Monatsbeginn oder zu Monatsende? Wenn am Monatsende, dann werden alle zusätzlichen Rückzahlungen, die in diesem Monat gemacht wurden, bereits in der Zins-Kapital-Relation der Rate reflektiert. Wenn zu Monatsbeginn, dann werden sie erst im folgenden Monat reflektiert.",
    "interestCalcMonthEnd": {
      "label": "Zinsen werden am Monatsende berechnet",
      "tooltip": "Wähle, ob die Zinsen am Ende jeden Monats berechnet werden sollen."
    }
  },
  "pension": {
    "wizardSteps": {
      "newAccount": {
        "title": "Neues Produkt",
        "subtitle": "Gib die grundlegenden Informationen zu diesem Rentenprodukt an, damit wir den Ablauf vorbereiten können."
      },
      "selectProduct": {
        "title": "Welche Produktart ist das?",
        "subtitle": "Wähle den Produkttyp oder die Vorlage, die am besten zu deinem Produkt passt."
      },
      "contributions": {
        "title": "Wie wird das Produkt bezahlt?",
        "subtitle": "Beschreibe, wie und wann Beiträge geleistet werden, damit wir die Entwicklung berechnen können."
      },
      "payouts": {
        "title": "Wie wird die Rente ausgezahlt?",
        "subtitle": "Teile uns mit, wie und in welchem Rhythmus die Auszahlungen in der Rentenphase erfolgen."
      },
      "payoutsAmount": {
        "title": "Wie hoch wird die Leistung?",
        "subtitle": "Trage die erwarteten Leistungsbeträge aus deiner Anbieterinformation ein. Du kannst mehrere Beträge eintragen und auswählen, welcher für die Vermögensberechnung verwendet wird.",
        "useThisCta": "Diesen Wert nutzen",
        "useThisActive": "✔️ Verwendet für Berechnungen",
        "payoutsAmountUseSpecialQuoteValidation": "Wähle aus, welcher Wert genutzt werden soll"
      },
      "connectedAccount": {
        "title": "Welche Konten werden genutzt?",
        "subtitle": "Verknüpfe die Bankkonten, über die Beiträge gezahlt und Auszahlungen empfangen werden."
      }
    },
    "provideInfo": "Bitte gib einige Details zu deinem Rentenkonto an.",
    "whyDoWeAsk": "Warum wollen wir das wissen?",
    "whyDoWeAskAnswer": "Wir verwenden diese Parameter, um den Wert deiner Rente zu berechnen und zukünftige Zahlungen zu simulieren.",
    "doIHaveToFillThemAllOut": "Muss ich alle diese Felder ausfüllen?",
    "doIHaveToFillThemAllOutAnswer": "Wir benötigen einige Informationen, um dir sinnvolle Auskünfte geben zu können. Felder, die als 'optional' gekennzeichnet sind, sind nicht zwingend erforderlich, werden jedoch verwendet, um weitere nützliche Daten für dich zu berechnen.",
    "payoutsAmountValidation": "Bitte gib mindestens einen Auszahlungsbetrag ein",
    "payoutsAmountUseSpecialQuoteValidation": "Wähle aus, welcher Wert genutzt werden soll",
    "useATemplate": "Benutze eine Vorlage!",
    "useATemplateAnswer": "Die gängigen Rentenprodukte wurden bereits für dich konfiguriert - wähle sie einfach aus der Liste aus.",
    "yourPensionContributions": "Beiträge - während der Ansparphase",
    "yourPensionPayouts": "Auszahlungen - wenn du in Rente gehst",
    "whenIBuy": "Wenn du Wertpapiere kaufst, das Geld...",
    "existingAccount": "...wird von einem bestehenden Bankkonto abgezogen.",
    "existingAccountSelect": "Wähle dieses Bankkonto aus.",
    "createAccountLater": "... wird von einem Bankkonto abgebucht, das ich später einrichten werde.",
    "createAccountLaterDescription": "Sobald du dieses Konto eingerichtet hast, denke daran, das verknüpfte Konto in diesem Konto zu aktualisieren."
  },
  "objectsOfValue": {
    "accountInfo": "Neues Konto hinzufügen",
    "provideInfo": "Bitte gib einige Details zu deinem Rentenkonto an.",
    "whyDoWeAsk": "Warum fragen wir das?",
    "whyDoWeAskAnswer": "Wir verwenden diese Parameter, um den Wert deiner Rente zu berechnen und zukünftige Zahlungen zu simulieren.",
    "whenIBuy": "Wenn ich Wertobjekte kaufe, wird das Geld...",
    "existingAccount": "... von einem bestehenden Bankkonto abgebucht",
    "existingAccountSelect": "Wähle dieses Bankkonto aus",
    "createAccountLater": "... von einem Bankkonto abgebucht, das ich später einrichten werde",
    "createAccountLaterDescription": "Sobald du dieses Konto eingerichtet hast, denke daran, das verknüpfte Konto in diesem Konto zu aktualisieren."
  },
  "metals": {
    "accountInfo": "Neues Konto hinzufügen",
    "provideInfo": "Du kannst entscheiden, wie du deine Edelmetall-Assets strukturieren möchtest, indem du sie in Konten organisierst. Du kannst mehrere Konten für verschiedene Metallarten oder verschiedene Lagerorte erstellen.",
    "whenIBuy": "Wenn ich Edelmetalle kaufe, wird das Geld...",
    "existingAccount": "... von einem bestehenden Bankkonto abgebucht",
    "existingAccountSelect": "Wähle dieses Bankkonto aus",
    "createAccountLater": "... von einem Bankkonto abgebucht, das ich später einrichten werde",
    "createAccountLaterDescription": "Sobald du dieses Konto eingerichtet hast, denke daran, das verknüpfte Konto in diesem Konto zu aktualisieren.",
    "apply": "Anwenden"
  },
  "unlistedShares": {
    "accountInfo": "Neues Konto hinzufügen",
    "provideInfo": "Bitte gib ein paar Grundinfos ein, um loszulegen. Sobald das Konto erstellt wurde, kannst du Bewertungen und weitere Einzahlungen hinzufügen.",
    "whenIBuy": "Wenn ich Edelmetalle kaufe, wird das Geld...",
    "existingAccount": "... von einem bestehenden Bankkonto abgebucht",
    "existingAccountSelect": "Wähle dieses Bankkonto aus",
    "createAccountLater": "... von einem Bankkonto abgebucht, das ich später einrichten werde",
    "createAccountLaterDescription": "Sobald du dieses Konto eingerichtet hast, denke daran, das verknüpfte Konto in diesem Konto zu aktualisieren.",
    "fxRate": "Wechselkurs: {{fxRate}}."
  },
  "crypto": {
    "accountInfo": "Neues Konto hinzufügen",
    "provideInfo": "Bitte gib ein paar Grundinfos ein, um loszulegen. Sobald das Konto erstellt wurde, kannst du ihm die eigentlichen Cryptoanlagen hinzufügen.",
    "whenIBuy": "Wenn ich Edelmetalle kaufe, wird das Geld...",
    "existingAccount": "... von einem bestehenden Bankkonto abgebucht",
    "existingAccountSelect": "Wähle dieses Bankkonto aus",
    "createAccountLater": "... von einem Bankkonto abgebucht, das ich später einrichten werde",
    "createAccountLaterDescription": "Sobald du dieses Konto eingerichtet hast, denke daran, das verknüpfte Konto in diesem Konto zu aktualisieren.",
    "createTechnicalAccount": "... von einem Geldkonto bei meiner Börse / Broker abgezogen",
    "createTechnicalAccountTooltip": "Wenn du diese Option auswählst, erstellen wir automatisch ein Geldkonto.",
    "createTechnicalAccountCurrency": "In welcher Währung ist dieses Geldkonto?",
    "apply": "Anwenden"
  }
}